<template>
  <tg-layout>
    <template slot="header">
      <tg-button
        v-if="!isAdmin && $user.permissions[14] > 1"
        border
        round
        theme="primary"
        hoverBorderOnly
        @click.native="handleSave"
      >
        {{ $t("component.btn.save") }}
      </tg-button>
    </template>

    <!-- 補上color參數 避免黑暗版的文字也變白 -->
    <tg-form-table
      :caption="title"
      :columns="columns"
      :data="tableData"
      :fenceRow="5"
      :fenceCol="2"
      :columnWidth="250"
      :cellWidth="350"
      :style="{ color: '#2e384d' }"
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name
          :column="scope.column"
          :row="scope.row"
        ></tg-user-full-name>
        <span
          v-if="!scope.row['mobile'] && !isSub && !isAdmin"
          class="ma-l-2 clickable"
          :title="registerMobile"
          @click="handleRegisterMobile"
        >
          <i class="tg-icon tg-icon-openAccount"></i>
        </span>
      </template>
      <template slot="password" slot-scope="scope">
        <el-input
          :placeholder="$t('component.form.input.placeholder.password[1]')"
          v-model="tableData[scope.column.name]"
          class="tg-input col-8"
          size="small"
          type="password"
          clearable
        ></el-input>
      </template>
      <template slot="blocked" slot-scope="scope">{{
        $t("enum." + scope.column.name + "[" + scope.value + "]")
      }}</template>
      <template slot="status" slot-scope="scope">
        <span>
          {{ $t("enum." + scope.column.langKey + "[" + scope.value + "]") }}
        </span>
      </template>
    </tg-form-table>
    <tg-register-mobile-dialog
      ref="registerMobile"
      :username="tableData.username"
    ></tg-register-mobile-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgButton from "@/components/button/TgButton";
import TgFormTable from "@/components/table/TgFormTable";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgRegisterMobileDialog from "@/components/dialog/TgRegisterMobileDialog";

import apis from "@/apis";
const api = apis.member.profile;

import validator from "@/mixins/validator";

export default {
  mixins: [validator],
  components: {
    TgLayout,
    TgButton,
    TgFormTable,
    TgUserFullName,
    TgRegisterMobileDialog,
  },
  data() {
    return {
      columns: [],
      tableData: {},
    };
  },
  created() {
    this.fetch();
  },
  computed: {
    title() {
      return this.$t("column.l" + this.$user.group + "_account");
    },
    request() {
      return {
        username: this.$user.username,
        group: this.$user.group,
      };
    },
    registerMobile() {
      return this.$t("page.member.profile.registerMobile");
    },
    siteTitle() {
      return this.$store.state.app.site;
    },
  },
  methods: {
    fetch() {
      api.getData(this.request).then((response) => {
        this.tableData = response.data;
        this.columns = response.columns;
      });
    },
    handleSave() {
      if (
        !this.tableData.password &&
        !this.tableData.newpassword &&
        !this.tableData.repassword
      ) {
        this.$message.info(this.$t("message.info.nochange"));
        return;
      }

      const isSite = ["SP", "RM", "JD"].includes(this.siteTitle);

      if (isSite) {
        // 026(SP), 005(RM), 045(JD) 的密碼規則
        if (
          !this.isSub &&
          !this.validatePasswordSpecial(this.tableData.newpassword)
        ) {
          return;
        }
      } else {
        if (!this.isSub && !this.validatePassword(this.tableData.newpassword)) {
          return;
        }
      }

      if (
        !this.validatePasswordChange(
          this.tableData.newpassword,
          this.tableData.repassword,
          isSite,
          "newpassword"
        )
      ) {
        return;
      }

      let proxy = apis.member.action;
      let request = {
        isPerson: true,
        ...this.tableData,
      };

      if (this.isSub) {
        proxy = apis.member.sub;
        request = {
          status: 1,
          password: this.tableData.newpassword,
          username: this.tableData.username,
        };
      }

      proxy.update(request).then((response) => {
        if (response.retcode == 0) {
          this.$message({
            message: this.$t("message.success.update"),
            offset: 150,
            type: "success",
          });
          this.fetch();
        } else {
          this.$message({
            message: this.$t("statusCode[" + response.retcode + "]"),
            offset: 150,
            type: "error",
          });
          this.fetch();
        }
      });
    },
    handleRegisterMobile() {
      this.$refs.registerMobile.show();
    },
  },
};
</script>
